import React from "react";
import Foundation from "@fast/fast-components-foundation-react";
import { classNames } from "@microsoft/fast-web-utilities";
import { Card } from "@fast/fast-components-react-msft";
import { DesignSystemConsumer, DesignSystemProvider } from "@fast/fast-jss-manager-react";
import { memoize } from "lodash-es";
import { createColorPalette } from "@fast/fast-components-styles-msft";
import { parseColorHexRGB } from "@microsoft/fast-colors";
import { Article } from "../article";
class ArticleCard extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            size: void 0,
            cardBackgroundColor: void 0,
        };
        this.getDesignSystemOverrides = memoize((designSystem, color) => {
            return Object.assign(designSystem, {
                backgroundColor: color,
                neutralPalette: createColorPalette(parseColorHexRGB(color)),
            });
        });
    }
    /**
     * Renders the component
     */
    render() {
        return (React.createElement(DesignSystemConsumer, null, (designSystem) => {
            return (React.createElement(DesignSystemProvider, { designSystem: this.getDesignSystemOverrides(designSystem, this.props.cardBackgroundColor) },
                React.createElement(Card, Object.assign({}, this.unhandledProps(), { className: this.generateClassNames() }),
                    React.createElement("div", { className: this.props.managedClasses.articleCard_container }, this.renderArticleWithProps()))));
        }));
    }
    /**
     *  Add props to Article
     */
    renderArticleWithProps() {
        return React.Children.map(this.props.children, (article, index) => {
            if (article.type !== Article) {
                return null;
            }
            return React.cloneElement(article, {
                key: index,
                card: true,
                wide: this.props.size === "_1x_2y" ? false : true,
            });
        });
    }
    /**
     * Generates class names
     */
    generateClassNames() {
        const { articleCard } = this.props.managedClasses;
        const sizeClassname = this.props.size === "_2x_2y"
            ? this.props.managedClasses.articleCard__2x_2y
            : this.props.managedClasses.articleCard__1x_2y;
        return super.generateClassNames(classNames(articleCard, sizeClassname));
    }
}
ArticleCard.displayName = "ArticleCard";
ArticleCard.defaultProps = {
    size: "_1x_2y",
    cardBackgroundColor: "#222",
};
export default ArticleCard;
export * from "./article-card.props";
